export { default as DownloadButton } from './component';
